import { FC } from 'react';
import { Switch } from '../../Switch/Switch';
import { IBaseFieldProps } from './types';

export const FieldBoolean: FC<IBaseFieldProps<unknown>> = ({ formField, formProps }) => {
  const { value, onChange } = formProps;
  const { disabled = false, label } = formField ?? {};

  return (
    <Switch
      checked={value ?? false}
      onChange={(checked) => onChange(checked)}
      disabled={disabled}
      size='small'
      aria-label={label}
    />
  );
};
